import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Slide from '@mui/material/Slide';
import Alert from '@mui/material/Alert';
import { useDispatch } from 'react-redux';
import { setToogleNotification } from './notificationQRSlice';

export default function TransitionsQRSnackbar({
  open,
  message,
  severity,
  color = '',
}) {
  const dispatch = useDispatch();

  const onHandleClose = (_, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    dispatch(setToogleNotification(false));
  };

  return (
    <Snackbar
      open={open}
      onClose={onHandleClose}
      autoHideDuration={5000}
      TransitionComponent={Slide}
      TransitionProps={{ direction: 'left' }}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      sx={{ marginTop: '56px' }}
    >
      <Alert
        variant="filled"
        severity={severity}
        sx={{ width: '100%' }}
        onClose={onHandleClose}
        color={color}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
